import React from 'react';
import PropTypes from 'prop-types';
export const CardMenuLocal = ({name, href}) => {
    return (
        <div className="bg-white mr-2 rounded mb-6 px-2 hover:bg-lightBlue-500  xl:mb-0 shadow-lg">
            <a className="text-blueGray-400  hover:text-white hover:font-bold  uppercase font-bold text-xs" href={href}>{name}</a>
        </div>
    );
};

CardMenuLocal.prototype = {
    name : PropTypes.string,
    href: PropTypes.string,
}
